import { registerGrpcClient } from 'libs/grpckit/src';
import { Module } from 'libs/uikit/ioc';
import { EventsClient, TicketVettingAutomationClient } from './api/Clients';

export interface OCSModuleConfig {
  webApiUrl: string;
}

export const ocsModule = (config: OCSModuleConfig) => {
  return new Module({
    providers: [
      registerGrpcClient(EventsClient, config.webApiUrl),
      registerGrpcClient(TicketVettingAutomationClient, config.webApiUrl),
    ],
  });
};
